import React from 'react';

export default function Alert({ size, color }) {
  return (
    <svg width={size} height={size} fill={color} viewBox='0 0 24 24'>
      <path d='M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z' />
    </svg>
  );
}
